import cx from 'classnames'
import type { ComponentProps, ReactNode } from 'react'

import { Alert } from '../../feedback/alert/Alert'
import { Stack } from '../stack/Stack'
import { Typography } from '../typography/Typography'
import { CardActions } from './CardActions'

type Props = {
  status?: Pick<ComponentProps<typeof Alert>, 'severity' | 'title' | 'children'>
  className?: string
  title: ReactNode
  shouldDisableTitleTypography?: boolean
} & (
  | {
      /**
       * @deprecated Use `actions` prop instead, this will be removed in future versions.
       */
      legacyChildren?: ReactNode
      actions?: never
    }
  | {
      /**
       * @deprecated Use `actions` prop instead, this will be removed in future versions.
       */
      legacyChildren?: never
      actions?: ComponentProps<typeof CardActions>['actions']
    }
)

export const CardHeader = ({
  title,
  shouldDisableTitleTypography,
  status,
  actions,
  className,
  legacyChildren,
}: Props) => (
  <Stack
    padding="normal"
    className={cx('items-center flex-wrap -my-1', className)}
  >
    {status && <Alert variant="mini" {...status} />}
    {shouldDisableTitleTypography ? (
      title
    ) : (
      <Typography weight="semibold" as="h2" intensity="primary">
        {title}
      </Typography>
    )}
    {actions && actions.length > 0 ? (
      <CardActions actions={actions} />
    ) : (
      <>
        {legacyChildren && (
          <div className="ml-auto -me-1.5 -my-1.5 flex items-center">
            {legacyChildren}
          </div>
        )}
      </>
    )}
  </Stack>
)
